import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DashboardOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DashboardOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M17 2H7C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5Zm3 5v1.5h-9.5V4H17c1.65 0 3 1.35 3 3ZM7 4h1.5v4.5H4V7c0-1.65 1.35-3 3-3ZM4 17v-6.5h9.5V20H7c-1.65 0-3-1.35-3-3Zm13 3h-1.5v-9.5H20V17c0 1.65-1.35 3-3 3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DashboardOutlined;